import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fd9aa5b4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dashboard-content-layout" }
const _hoisted_2 = {
  key: 0,
  class: "dashboard-content-layout__state"
}
const _hoisted_3 = {
  key: 1,
  class: "dashboard-content-layout__state"
}
const _hoisted_4 = {
  key: 2,
  class: "dashboard-content-layout__grid"
}
const _hoisted_5 = { class: "dashboard-content-layout__left" }
const _hoisted_6 = { class: "dashboard-content-layout__center" }
const _hoisted_7 = { class: "dashboard-content-layout__right" }

import WidgetState from '@/components/dashboard/WidgetState.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'DashboardContentLayout',
  props: {
    metaLoading: { type: Boolean },
    metaError: { type: Boolean }
  },
  emits: ["retry-meta"],
  setup(__props: any) {





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.metaLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(WidgetState, {
            variant: "loading",
            "loading-text": "Đang tải cấu hình dashboard..."
          })
        ]))
      : (_ctx.metaError)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(WidgetState, {
              variant: "error",
              "error-title": "Không tải được cấu hình dashboard",
              "error-text": "API meta chưa sẵn sàng hoặc có lỗi kết nối.",
              onRetry: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('retry-meta')))
            })
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("aside", _hoisted_5, [
              _renderSlot(_ctx.$slots, "left")
            ]),
            _createElementVNode("main", _hoisted_6, [
              _renderSlot(_ctx.$slots, "center")
            ]),
            _createElementVNode("aside", _hoisted_7, [
              _renderSlot(_ctx.$slots, "right")
            ])
          ]))
  ]))
}
}

})